import { createFileRoute } from '@tanstack/react-router';
import { StudySessionDetail } from '@/components/Modules/StudySessionDetail';

export const Route = createFileRoute('/sessions/$id')({
  component: StudySessionDetail,
});
